import {MetaTitleDesc} from "./../meta";
import DocumentMeta from "react-document-meta";

export default () => {
    const title = 'Общепринятые сокращения';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    <div className="two-col-cell gallery">
                        <h3>ЦЕНЫ</h3>
                        <p><strong>SGL (Sngl)</strong> одноместный номер</p>
                        <p><strong>SGL (Sngl)</strong> одноместный номер</p>
                        <p><strong>DBL</strong> двухместный номер</p>
                        <p><strong>Twin</strong> двухмествный номер с двумя кроватями</p>
                        <p><strong>EXB (Extra Bed)</strong> двухместный + дополнительная кровать</p>
                        <p><strong>Trpl</strong> трехместный номер</p>
                        <p><strong>Quad</strong> четырехместный номер</p>
                        <p><strong>ch (Child)</strong> маленький ребенок, например 0-6 лет</p>
                        <p><strong>CH</strong> большой ребенок, в основном до 12 лет, но по ряду отелей до 15 лет</p>
                        <p><strong>Sc</strong> маленький ребенок + 1 взрослый</p>
                        <p><strong>SC</strong> большой ребенок + 1 взрослый</p>
                        <p><strong>Dc</strong> маленький ребенок + 2 взрослых</p>
                        <p><strong>DC</strong> большой ребенок + 2 взрослых</p>
                        <p><strong>Per person, pax</strong> за человека</p>
                    </div>
                    <div className="two-col-cell gallery">
                        <h3>ПИТАНИЕ</h3>
                        <p><strong>ВО</strong> без питания</p>
                        <p><strong>BB (AMB)</strong> завтраки (Шведский стол)</p>
                        <p><strong>CB (EB)</strong> Континентальный завтрак</p>
                        <p><strong>HB</strong> полупансион (Завтрак и обед или завтрак и ужин)</p>
                        <p><strong>HB+</strong> Расширенный полупансион</p>
                        <p><strong>FB</strong> полный пансион (Трехразовое питание)</p>
                        <p><strong>FB+</strong> Расширенный полный пансион</p>
                        <p><strong>all inc</strong> питание в течение дня, включая напитки местного производства</p>
                        <p><strong>ultra all inc</strong> питание в течение дня, включая напитки импортного производства</p>
                        <p><strong>max all inc</strong> питание в течение дня, включая напитки импортного производства и дополнительные услуги</p>
                        <p><strong>AI</strong> Все включено</p>
                        <p><strong>high class all inc</strong> питание высшей категории</p>
                        <p><strong>Ex all inc</strong> Расширенный all inc</p>
                        <p><strong>El all inc</strong> Элегантный all inc</p>
                        <p><strong>VIP all inc</strong> Very Important Person all inc</p>
                        <p><strong>Super All inc</strong> Super All inc</p>
                        <p><strong>De Luxe All Inc</strong> Расширенный all inc</p>
                        <p><strong>EP (RO)</strong> Без питания</p>
                    </div>
                    <div className="two-col-cell gallery">
                        <h3>ТИП РАЗМЕЩЕНИЯ</h3>
                        <p><strong>ROH</strong> без уточнения размещения</p>
                        <p><strong>MB</strong> основное здание</p>
                        <p><strong>BG</strong> бунгало</p>
                        <p><strong>De Luxe</strong> номера повышенной комфортности</p>
                        <p><strong>Superior</strong> комната большего размера, чем стандартная</p>
                        <p><strong>Chale</strong> пристройки к основному зданию</p>
                        <p><strong>Mini-suite</strong> номер улучшенной категории, лучше чем Superior</p>
                        <p><strong>Sea view</strong> вид на море</p>
                        <p><strong>Ex. suite</strong> сьюты с 2-мя спальнями</p>
                        <p><strong>Suite</strong> номер улучшенной планировки и категории(люкс)</p>
                        <p><strong>Garden view</strong> вид на сад</p>
                        <p><strong>Studio</strong> однокомнатный номер, больше стандартного</p>
                        <p><strong>City view</strong> вид на город</p>
                        <p><strong>Dune view</strong> вид на песок</p>
                        <p><strong>Dune room</strong> бунгало на втором плане</p>
                        <p><strong>Pavilion</strong> название корпуса</p>
                        <p><strong>Mountain view</strong> вид на горы</p>
                        <p><strong>Room</strong> размещение в однокомнатном номере</p>
                        <p><strong>Sport-Area</strong> название корпуса</p>
                        <p><strong>Pool view</strong> вид на бассейн</p>
                        <p><strong>Land view</strong> вид на окрестности</p>
                        <p><strong>Park view</strong> вид на парк</p>
                        <p><strong>Front</strong> 1 береговая линия</p>
                        <p><strong>Standart Room</strong> стандартная комната</p>
                        <p><strong>1 BDRM</strong> Аппартаменты с 1-й спальней</p>
                        <p><strong>2 BDRM</strong> Аппартаменты с 2-я спальнями</p>
                        <p><strong>Terrace</strong> тераса</p>
                        <p><strong>New Building</strong> Новое здание</p>
                        <p><strong>Golf view</strong> Вид на залив</p>
                        <p><strong>Junior suite</strong> Номер улучшеной планировки (полулюкс)</p>
                        <p><strong>Duplex</strong> Двухуровневый номер</p>
                        <p><strong>Balcony room</strong> Номер с балконом</p>
                        <p><strong>Jungle view</strong> вид на джунгли</p>
                        <p><strong>Ocean view</strong> Вид на океан</p>
                        <p><strong>Jacuzzi villa</strong> Вилла с джакуззи</p>
                        <p><strong>Villа</strong> размещение в бунгало</p>
                        <p><strong>Superior/Main Building</strong> комната большего размера в главном здании</p>
                        <p><strong>Garden Villa, Superior</strong> бунгало с видом на сад, комната в здании</p>
                    </div>
                </div>
            </div>
        </>
    );
}